<template>
  <naj-modal
    ref="modal"
    title="الشروط و الاحكام"
    :width="1000"
    :footer="true"
    @onClose="closeModal"
  >
    <v-row
      v-for="(item, index) in caseClassification"
      :key="index"
    >
      <v-col
        v-if="item.nonSpecialityAttachmentAcceptanceCriteria !=null"
        cols="12"
      >
        <h1>{{ local.caseRelatedProcedure.acceptanceCriteria }} {{ item.name }} :</h1>
        <h2 style="font-size: 18px;padding: 14px;">
          <naj-input
            :type-id="formFieldType.textarea"
            :value.sync="item.nonSpecialityAttachmentAcceptanceCriteria"
            disabled="true"
          ></naj-input>
        </h2>
      </v-col>
    </v-row>

    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button @click="submit(closeNajModal)">
        {{ local.common.AcceptAndApprove }}
      </naj-button>
    </template>
  </naj-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { caseClassificationEnum } from '@/helpers/enum';

export default {
  name: 'AcceptanceCriteriaModal',
  props: ['params', 'caseClassification'],
  data() {
    return { caseClassificationEnum };
  },
  watch: {},
  mounted() {
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    closeModal() {
      this.$refs.modal.close();
    },
    submit() {
      this.$emit('onSubmit');
    },
  },
};
</script>